import React from 'react';
import Moment from'moment';
import ATable from '../../common/table';
import Constants from '../../../configurations/constants';

const SettlementRequestsTable = (props) => {


    const columns = [{
        header: "S/N",
        width: 50,
        render: row => (<div>{row.viewIndex + 1}</div>)
    },
    {
        
        header: "Dispute Log code",
        accessor: "disputeLogCode",
        render: row => { return row.row.disputeLogCode; },
        width: 150
    },

    {
      
        header: "Settlement Type",
        accessor: "settlementType",
        render: row => { return row.row.settlementType; }
    },

    {
       
        header: "Phase",
        accessor: "phase",
        render: row => { return row.row.phase; }
    },

    {
        
        header: "Request Reference",
        accessor: "requestReference",
        render: row => { return row.row.requestReference; },
        width: 300
    },
    {
        header: "Status",
        accessor: "status",
        render: row => { return row.row.status; }
    },

    {
       
        header: "Status Message",
        accessor: "statusMessage",
        render: row => { return row.row.statusMessage; }

    },

    {
        header: "Created By",
        accessor: "createdBy",
        render: row => { return row.row.createdBy; }

    },

    {
        header: "Created On",
        accessor: "createdOn",
        render: row => { return  Moment(row.row.createdOn).format(Constants.DATE_FORMAT_LONG); }

    },
    {
        header: "Last Updated By",
        accessor: "lastUpdatedBy",
        render: row => { return row.row.lastUpdatedBy; }

    },

    {
        header: "Last Updated On",
        accessor: "lastUpdatedOn",
        render: row => { return !row.row.lastUpdatedOn ? "" : Moment(row.row.lastUpdatedOn).format(Constants.DATE_FORMAT_LONG); }

    },
    {
        header: "Actions",
        width :300,
        render: (cellInfo) => { 
            let request  = cellInfo.row;
            if(request.status === Constants.SETTLEMENT_REQUEST_STATUS_MAPPING){
                return (
                    <button 
                        className="btn btn-primary" 
                        disabled={props.disableActions}
                        onClick={(evt) => request.clickHandler(cellInfo.index,Constants.SETTLEMENT_REQUEST_ACTION_MAP)}>MAP
                    </button>
                );
            }
            if(request.status === Constants.SETTLEMENT_REQUEST_STATUS_PENDING){
                return (
                    <div className="actions">
                        <button 
                            onClick={(evt) => request.clickHandler(cellInfo.index,Constants.SETTLEMENT_REQUEST_ACTION_PROCESS)}
                            disabled={props.disableActions}
                            className="btn btn-primary">PROCESS
                         </button>
                         <button 
                            onClick={(evt) => request.clickHandler(cellInfo.index,Constants.SETTLEMENT_REQUEST_ACTION_CANCEL)}
                            disabled={props.disableActions}
                            className="btn btn-danger">CANCEL
                         </button>
                         
                    </div>
                )
            }
        }

    },


    ];
    return (
        <ATable
            className="-striped -highlight"
            tableData={props.settlementRequests}
            columns={columns}
            onChange={props.onTableChange || null}
            manual
            {...props} />
    )
};

export default SettlementRequestsTable;


// WEBPACK FOOTER //
// ./src/components/admin/settlementRequests/settlementRequestsTable.js